module.exports = __webpack_public_path__ + "img/20200725.569dee7c.png";